import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import PageLoading from '@/components/Loaders/PageLoading';

import AvatarEmbedWrapper from './AvatarEmbedWrapper';

// Configures router using createBrowserRouter
const configureRouter = () => {
  const NoAuthRoute = ({ user, children }) => {
    return <Suspense>{children}</Suspense>;
  };
  return createBrowserRouter([
    {
      path: '/embed/avatar',
      element: (
        <NoAuthRoute>
          <AvatarEmbedWrapper />
        </NoAuthRoute>
      )
    }
  ]);
};

// Routers component responsible for rendering router provider
const Routers = () => {
  const router = configureRouter();
  return <RouterProvider router={router} fallbackElement={<PageLoading loading />} />;
};

export default Routers;
